import { render, staticRenderFns } from "./VircosDelivery.vue?vue&type=template&id=867f70fc&scoped=true"
import script from "./VircosDelivery.vue?vue&type=script&lang=js"
export * from "./VircosDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f70fc",
  null
  
)

export default component.exports